<template>
  <div class="PoinDels">
    <div class="PoinDels-background" @scroll="podrsh($event)">
      <div class="NewCape-AppTitle">
        <img src="../../public/obraoag/NewCapeReturn.png" alt="" @click="BackLevel()">
        积分明细界面
      </div>
      <div class="PoinDels-time" v-if="this.poexsm == '0'">
        <div v-for="erpogrta in pogrta" :key="erpogrta.ID">
          <div class="PoinDels-time-yest-tald" v-for="blerpogrta in erpogrta.userIntegralDto" :key="blerpogrta.ID">
            <div class="PoinDels-time-yest-taldleft">
              <p class="PoinDels-time-yest-taldtop" v-if="blerpogrta.region == '1'">{{Math.floor(blerpogrta.amount * 100) / 100}} (0-90天)</p>
              <p class="PoinDels-time-yest-taldtop" v-else-if="blerpogrta.region == '2'">{{Math.floor(blerpogrta.amount * 100) / 100}} (90-180天)</p>
              <p class="PoinDels-time-yest-taldtop" v-else-if="blerpogrta.region == '3'">{{Math.floor(blerpogrta.amount * 100) / 100}} (180天)</p>
              <p class="PoinDels-time-yest-taldtop" v-else-if="blerpogrta.region == '10'">{{Math.floor(blerpogrta.amount * 100) / 100}} (冻结欧宝)</p>
              <p class="PoinDels-time-yest-taldbtn">{{blerpogrta.cdate}}</p>
            </div>
            <div class="PoinDels-time-yest-taldright">{{Math.floor(blerpogrta.integral * 100) / 100}}</div>
          </div>
        </div>
      </div>
      <div class="PoinDels-time" v-else-if="this.poexsm == '1'">
        <div class="PoinDels-time-yest-tald" v-for="blerpogrta in pogrta" :key="blerpogrta.ID">
          <div class="PoinDels-time-yest-taldleft">
            <p class="PoinDels-time-yest-taldtop" v-if="blerpogrta.REGION == '1'">{{Math.floor(blerpogrta.AMOUNT * 100) / 100}} (0-90天)</p>
            <p class="PoinDels-time-yest-taldtop" v-else-if="blerpogrta.REGION == '2'">{{Math.floor(blerpogrta.AMOUNT * 100) / 100}} (90-180天)</p>
            <p class="PoinDels-time-yest-taldtop" v-else-if="blerpogrta.REGION == '3'">{{Math.floor(blerpogrta.AMOUNT * 100) / 100}} (180天)</p>
            <p class="PoinDels-time-yest-taldtop" v-else-if="blerpogrta.REGION == '10'">{{Math.floor(blerpogrta.AMOUNT * 100) / 100}} (冻结欧宝)</p>
            <p class="PoinDels-time-yest-taldbtn">{{blerpogrta.CDATE}}</p>
          </div>
          <div class="PoinDels-time-yest-taldright">{{Math.floor(blerpogrta.INTEGRAL * 100) / 100}}</div>
        </div>
      </div>
    </div>
    <!-- 失败提示 -->
    <div id="warnToast" :style="'display:' + poinfail">
      <div class="weui-mask_transparent"></div>
      <div class="weui-toast">
        <i class="weui-icon-warn weui-icon_toast"></i>
        <p class="weui-toast__content">{{pointips}}</p>
      </div>
    </div>
    <!-- 加载中 -->
    <PageLong :style="'display:' + poinlong"></PageLong>
  </div>
</template>

<script>
import "./obraojs/rem"
export default {
  data () {
    return{
      loginID: '',
      pocner: '',
      poinfail: 'none',
      pointips: '',
      pogrta: '',
      pomets: '',
      poexsm: '',
      potnes: '1',
      poavts: '',
      poinlong: 'block'
    }
  },
  created () {
    // 从缓存里获取token
    this.loginID = localStorage.getItem("usertoken");
    // 接收积分传过来的跳转状态
    this.pomets = this.$route.query.inmets;
    // 接收积分传过来的卡号
    this.pocner = this.$route.query.incner;
    // 接收积分传过来的可用积分
    this.poavts = this.$route.query.inavts;
    // 判断执行哪个系统
    this.$axios.post('wx/isnotoldornew',this.$qs.stringify({}),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
    .then(res => {
      this.poexsm = res.data.flag;
      if(res.data.flag == '0'){
        // 执行老系统
        this.$axios.post('wx/userIntegral',this.$qs.stringify({
          token: this.loginID,
          cnumber: this.pocner
        }),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
        .then(res => {
          this.poinlong = 'none';
          if(res.data.code == '200'){
            this.pogrta = res.data.data;
          }else{
            this.pointips = res.data.msg;
            this.poinfail = 'block';
            const _this = this;
            setTimeout(function(){
              _this.poinfail = 'none';
            },1200)
          }
        })
        .catch(() => {
          console.log('获取失败');
        });
      }else if(res.data.flag == '1'){
        // 执行新系统
        this.$axios.post('wx/usernewIntegralList',this.$qs.stringify({
          cnumber: this.pocner,
          KEYWORDS: '',
          showCount: '18',
          currentPage: this.potnes
        }),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
        .then(res => {
          this.poinlong = 'none';
          this.pogrta = res.data.data;
        })
        .catch(() => {
          console.log('获取失败');
        });
      }
    })
    .catch(() => {
      console.log('获取失败');
    });
  },
  mounted () {

  },
  methods: {
    // 滚动条触底加载新的数据
    podrsh(e){
      let scrollTop = Math.ceil(e.target.scrollTop);
      let scrollHeight = e.target.scrollHeight;
      let offsetHeight = Math.ceil(e.target.getBoundingClientRect().height);
      let currentHeight = scrollTop + offsetHeight;
      if (currentHeight >= scrollHeight && this.poexsm == '1') {
        this.potnes = Number(this.potnes) + 1;
        this.poinlong = 'block';
        // 执行新系统
        this.$axios.post('wx/usernewIntegralList',this.$qs.stringify({
          cnumber: this.pocner,
          KEYWORDS: '',
          showCount: '18',
          currentPage: this.potnes
        }),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
        .then(res => {
          this.poinlong = 'none';
          if(Number(this.potnes) <= Number(res.data.page.totalPage)){
            this.pogrta = [...this.pogrta,...res.data.data]
          }
        })
        .catch(() => {
          console.log('获取数据失败');
        });
      }
    },
    // 返回上一层
    BackLevel(){
      this.$router.push({name: 'integral',query: {seheus: this.pomets,seigal: this.poavts,sechbr: this.pocner}});
    }
  }
}
</script>

<style scoped>
  @import "obraocs/PoinDels.css";
</style>